<template lang="html">
  <template v-if="!$store.state.organ.pipeVariantsScreenIsShown">
    <div v-if="!isMobile" class="page-info-back">
      <Back
        v-if="globalSettings"
        color="#0062ae"
        :label="globalSettings['button_names']['back_button']"
      />
    </div>
    <div class="page-info organ" v-if="initialData && isMobile">
      <div v-if="isMobile" class="page-info__back">
        <Back label="" color="#C99D66" />
      </div>
      <div class="page-info__image" v-if="initialData.image">
        <img
          :src="initialData.image.sizes['medium_large']"
          :alt="initialData.image.alt"
        />
      </div>
      <div class="page-info__container">
        <div v-if="globalSettings" class="page-info__heading">
          <Heading :text="globalSettings.price_range_title" :hType="1" />
        </div>
        <div class="page-info__donations"></div>
      </div>
    </div>
    <div
      class="gray-background page-info page-info--desktop organ"
      v-if="initialData"
    >
      <div class="row">
        <div v-if="!isMobile" class="left">
          <div class="page-info__image" v-if="initialData.image">
            <div>
              <img
                :src="initialData.image.sizes['medium_large']"
                :alt="initialData.image.alt"
              />
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="!isMobile" class="page-info__container">
            <div v-if="globalSettings" class="page-info__heading">
              <Heading :text="globalSettings.price_range_title" :hType="1" />
            </div>
          </div>
          <div class="page-info__container">
            <div v-if="globalSettings" class="page-info__donations">
              <div
                class="page-info__donation"
                v-for="donation in donations"
                :key="donation.id"
                :class="{
                  active: donation.id === $store.state.organ.selectedDonation,
                }"
                @click="$store.commit('organ/setSelectedDonation', donation.id)"
              >
                {{ donation.label }}
              </div>
            </div>
            <div class="page-info__text">
              <div class="page-info__text-title">
                {{ globalSettings.pipe_title_after_ranges }}
              </div>
              <div
                class="page-info__text-description"
                v-html="globalSettings.pipe_description_after_ranges"
              ></div>
              <div class="page-info__text-links">
                <a :href="`tel:${globalSettings.pipe_phone_after_ranges}`">
                  <span class="icon"
                    ><svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2646_138)">
                        <path
                          d="M17.4492 15.3156L15.0093 13.4703C14.7045 13.1784 14.2999 13.0141 13.8783 13.0109C13.682 13.0094 13.4873 13.0469 13.3056 13.1214C13.1239 13.1959 12.9588 13.3058 12.8198 13.4447C12.8123 13.4521 12.8049 13.4602 12.7981 13.4677L11.1198 15.369C8.86276 13.7635 6.8917 11.7887 5.28928 9.52746L7.18668 7.84596L7.20995 7.82427C7.35572 7.6781 7.46946 7.50306 7.5439 7.31036C7.61834 7.11766 7.65186 6.91152 7.64229 6.70511C7.62604 6.30307 7.46312 5.92098 7.18442 5.63127L5.3426 3.1864C5.32739 3.16644 5.31087 3.14751 5.29316 3.12975C5.10234 2.89448 4.86361 2.70272 4.5929 2.56729C4.3222 2.43185 4.02577 2.35585 3.72341 2.34436C3.42077 2.34947 3.12119 2.40595 2.83739 2.51141C1.6932 2.91187 1.22399e-05 4.55743 1.22399e-05 6.81712C-0.00548092 9.13509 1.83829 12.3854 4.93287 15.5173C4.94257 15.5289 4.95323 15.5402 4.96518 15.5512L4.98877 15.5736L5.01139 15.5969L5.03886 15.6247C5.04823 15.6338 5.05792 15.6429 5.06794 15.6513C8.18838 18.7462 11.5376 20.667 13.8153 20.667H13.8237C16.0801 20.667 17.7226 18.9702 18.1213 17.8239C18.5976 16.4587 17.9391 15.7989 17.5028 15.3635C17.486 15.3464 17.4681 15.3303 17.4492 15.3156ZM17.1261 17.4759C16.8747 18.1965 15.6103 19.6093 13.8247 19.6093L13.8173 20.1389V19.6093C11.8313 19.6093 8.67953 17.7498 5.7856 14.8724C5.77753 14.8643 5.76912 14.8562 5.7604 14.8487C5.75168 14.8413 5.74489 14.8326 5.73584 14.8238L5.71516 14.8018C2.83933 11.8992 1.05567 8.84146 1.06052 6.81972C1.06052 5.03171 2.47032 3.76492 3.18992 3.51338C3.36178 3.448 3.54323 3.41146 3.72696 3.40525C4.05009 3.40525 4.23491 3.56712 4.52411 3.85589L6.36206 6.2972C6.37684 6.31672 6.39293 6.33522 6.41021 6.35256C6.51682 6.45651 6.5802 6.59704 6.5876 6.7459C6.59105 6.80438 6.58276 6.86296 6.56322 6.91818C6.54369 6.97339 6.5133 7.02412 6.47387 7.06737L4.2417 9.04541C4.14599 9.13014 4.08413 9.24671 4.06756 9.37359C4.05098 9.50047 4.08082 9.62907 4.15155 9.73562C5.9589 12.4023 8.25416 14.7018 10.9159 16.5124C11.0222 16.5833 11.1504 16.6132 11.277 16.5967C11.4036 16.5801 11.5199 16.5182 11.6045 16.4224L13.5791 14.1857C13.6611 14.1103 13.769 14.0695 13.8803 14.0718C14.0357 14.0745 14.1837 14.1384 14.2926 14.2495C14.3098 14.2667 14.3281 14.2827 14.3475 14.2974L16.7845 16.1395C17.17 16.5263 17.3771 16.7546 17.1254 17.4759H17.1261Z"
                          fill="#B27644"
                        />
                        <path
                          d="M14.0307 6.64719C14.4542 7.07399 14.7853 7.58367 15.0033 8.14441C15.2214 8.70516 15.3217 9.30493 15.298 9.90626C15.294 10.0466 15.3458 10.1829 15.442 10.285C15.5382 10.3871 15.671 10.4467 15.8111 10.4508H15.8266C15.9642 10.4508 16.0962 10.397 16.1948 10.3009C16.2934 10.2049 16.3508 10.0741 16.3546 9.93636C16.3843 9.1907 16.2596 8.44697 15.9883 7.75197C15.717 7.05697 15.3051 6.42576 14.7784 5.89808C14.2517 5.3704 13.6217 4.95767 12.928 4.68589C12.2343 4.4141 11.492 4.28914 10.7477 4.31887C10.6076 4.32293 10.4748 4.38258 10.3786 4.48469C10.2824 4.5868 10.2306 4.72302 10.2346 4.86339C10.2405 5.00317 10.3005 5.13513 10.4021 5.2312C10.5036 5.32728 10.6385 5.37988 10.7781 5.37781C11.3782 5.35405 11.9768 5.45451 12.5364 5.67291C13.0961 5.89132 13.6047 6.22298 14.0307 6.64719Z"
                          fill="#B27644"
                        />
                        <path
                          d="M17.4243 3.24762C16.5636 2.38962 15.5359 1.71828 14.4051 1.27538C13.2742 0.832494 12.0645 0.627533 10.8512 0.673257C10.7111 0.67732 10.5784 0.736965 10.4821 0.839078C10.3859 0.94119 10.3341 1.07741 10.3381 1.21778C10.3391 1.28762 10.354 1.35655 10.3821 1.4205C10.4101 1.48445 10.4507 1.54212 10.5013 1.59008C10.552 1.63805 10.6118 1.67534 10.6771 1.69975C10.7424 1.72416 10.812 1.7352 10.8816 1.7322C11.9514 1.68737 13.0188 1.86544 14.0164 2.25515C15.0139 2.64487 15.9199 3.23775 16.677 3.99629C17.4341 4.75483 18.0259 5.66253 18.4149 6.66197C18.8039 7.66142 18.9816 8.73087 18.9368 9.80267C18.9329 9.94307 18.9848 10.0793 19.0811 10.1814C19.1774 10.2835 19.3102 10.3431 19.4503 10.3472H19.4655C19.603 10.3472 19.7351 10.2934 19.8337 10.1974C19.9323 10.1013 19.9896 9.9705 19.9935 9.83278C20.04 8.61716 19.8359 7.40497 19.3939 6.27194C18.9518 5.13891 18.2813 4.10936 17.4243 3.24762Z"
                          fill="#B27644"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2646_138">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0 0.666992)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span class="label">{{
                    globalSettings.pipe_phone_after_ranges
                  }}</span>
                </a>
                <a :href="`mailto:${globalSettings.pipe_email_after_ranges}`">
                  <span class="icon">
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.83132 12.4404C4.83132 12.2947 4.77343 12.1549 4.67039 12.0519C4.56735 11.9488 4.42759 11.8909 4.28186 11.8909C3.69057 11.8903 3.12367 11.6552 2.70557 11.2371C2.28746 10.819 2.05231 10.2521 2.05171 9.66077V3.49842C2.05256 2.90721 2.28779 2.34046 2.70584 1.92241C3.12389 1.50436 3.69065 1.26912 4.28186 1.26827H13.1307C13.5403 1.2676 13.9421 1.37994 14.2919 1.59294C14.6417 1.80593 14.9259 2.11131 15.1133 2.47546C15.1465 2.53962 15.1921 2.5966 15.2473 2.64316C15.3025 2.68972 15.3664 2.72495 15.4353 2.74683C15.5041 2.76871 15.5766 2.77681 15.6486 2.77068C15.7205 2.76454 15.7906 2.74429 15.8548 2.71108C15.9189 2.67787 15.9759 2.63234 16.0225 2.57711C16.069 2.52187 16.1043 2.45801 16.1261 2.38916C16.148 2.32031 16.1561 2.24782 16.15 2.17584C16.1439 2.10386 16.1236 2.03379 16.0904 1.96963C15.8107 1.42607 15.3864 0.970241 14.8642 0.652318C14.3421 0.334395 13.7424 0.166711 13.1311 0.167729H4.28121C3.39803 0.168756 2.55133 0.520075 1.92685 1.14461C1.30238 1.76914 0.951136 2.61589 0.950195 3.49907V9.66109C0.951479 10.544 1.3029 11.3903 1.92737 12.0144C2.55183 12.6385 3.39834 12.9894 4.28121 12.9902C4.35345 12.9903 4.425 12.9761 4.49176 12.9485C4.55852 12.9209 4.61918 12.8804 4.67027 12.8294C4.72137 12.7783 4.76189 12.7177 4.78952 12.6509C4.81716 12.5842 4.83136 12.5126 4.83132 12.4404Z"
                        fill="#B27644"
                      />
                      <path
                        d="M17.6193 3.7699H8.77038C7.88723 3.77084 7.04053 4.12209 6.41604 4.74657C5.79156 5.37105 5.44031 6.21776 5.43937 7.10091V13.2419C5.29877 17.018 4.65913 17.8564 4.44743 18.1344C4.37048 18.2279 4.32177 18.3414 4.307 18.4616C4.29223 18.5818 4.31202 18.7038 4.36404 18.8131C4.42259 18.9253 4.51249 19.0179 4.6228 19.0799C4.7331 19.1418 4.85904 19.1703 4.98526 19.1619C4.99915 19.1619 5.04311 19.1603 5.05733 19.1593C7.26713 18.9864 8.40095 17.7598 9.31208 16.7743C9.36832 16.7131 9.42424 16.6528 9.47984 16.5933H17.6193C18.5021 16.5925 19.3487 16.2416 19.9731 15.6175C20.5976 14.9934 20.949 14.1471 20.9503 13.2642V7.10091C20.9493 6.21776 20.5981 5.37105 19.9736 4.74657C19.3491 4.12209 18.5024 3.77084 17.6193 3.7699ZM19.8494 13.2639C19.8488 13.8552 19.6137 14.4221 19.1956 14.8402C18.7775 15.2583 18.2106 15.4935 17.6193 15.4941H9.2426C9.16838 15.494 9.09492 15.509 9.02665 15.5381C8.95838 15.5672 8.89671 15.6098 8.84537 15.6634C8.73289 15.7808 8.61912 15.9033 8.50406 16.0283C7.79299 16.7973 7.06254 17.5878 5.82431 17.9194C6.12813 17.1599 6.44552 15.8098 6.5399 13.2652V7.10091C6.54067 6.50968 6.77588 5.94287 7.19395 5.52481C7.61202 5.10674 8.17882 4.87152 8.77006 4.87076H17.6189C18.2102 4.87152 18.777 5.10674 19.1951 5.52481C19.6131 5.94287 19.8483 6.50968 19.8491 7.10091L19.8494 13.2639Z"
                        fill="#B27644"
                      />
                      <path
                        d="M10.4056 9.5863C10.2424 9.58637 10.083 9.63481 9.94736 9.72549C9.81176 9.81618 9.70608 9.94504 9.64371 10.0958C9.58134 10.2465 9.56508 10.4124 9.59697 10.5724C9.62886 10.7324 9.70748 10.8793 9.82288 10.9946C9.93828 11.1099 10.0853 11.1884 10.2453 11.2202C10.4053 11.252 10.5711 11.2356 10.7218 11.1731C10.8725 11.1106 11.0013 11.0048 11.0919 10.8691C11.1825 10.7334 11.2308 10.574 11.2307 10.4108C11.2307 10.3025 11.2093 10.1952 11.1678 10.0952C11.1263 9.99513 11.0655 9.90423 10.9889 9.82766C10.9123 9.7511 10.8213 9.69038 10.7212 9.64897C10.6212 9.60755 10.5139 9.58626 10.4056 9.5863Z"
                        fill="#B27644"
                      />
                      <path
                        d="M13.4163 9.5863C13.2532 9.58637 13.0937 9.63481 12.9581 9.72549C12.8225 9.81618 12.7168 9.94504 12.6545 10.0958C12.5921 10.2465 12.5758 10.4124 12.6077 10.5724C12.6396 10.7324 12.7182 10.8793 12.8336 10.9946C12.949 11.1099 13.096 11.1884 13.256 11.2202C13.4161 11.252 13.5819 11.2356 13.7326 11.1731C13.8833 11.1106 14.0121 11.0048 14.1026 10.8691C14.1932 10.7334 14.2415 10.574 14.2415 10.4108C14.2414 10.3025 14.2201 10.1952 14.1786 10.0952C14.1371 9.99513 14.0763 9.90423 13.9997 9.82766C13.923 9.7511 13.8321 9.69038 13.732 9.64897C13.6319 9.60755 13.5246 9.58626 13.4163 9.5863Z"
                        fill="#B27644"
                      />
                      <path
                        d="M16.4267 9.5863C16.2636 9.58643 16.1042 9.63493 15.9686 9.72565C15.8331 9.81638 15.7274 9.94526 15.6651 10.096C15.6028 10.2468 15.5866 10.4126 15.6185 10.5726C15.6504 10.7325 15.7291 10.8795 15.8445 10.9947C15.9599 11.11 16.1069 11.1885 16.2669 11.2202C16.4269 11.252 16.5927 11.2355 16.7434 11.173C16.8941 11.1105 17.0228 11.0048 17.1134 10.8691C17.204 10.7334 17.2523 10.5739 17.2522 10.4108C17.2522 10.3025 17.2308 10.1952 17.1893 10.0951C17.1478 9.99504 17.0869 9.90412 17.0103 9.82755C16.9336 9.75098 16.8426 9.69027 16.7425 9.64888C16.6424 9.60748 16.5351 9.58622 16.4267 9.5863Z"
                        fill="#B27644"
                      />
                    </svg>
                  </span>
                  <span class="label">
                    {{ globalSettings.pipe_email_after_ranges }}
                  </span>
                </a>
              </div>
            </div>
            <div class="page-info__buttons">
              <Button styleButton="border" @click="$router.go(-1)">
                <span>Abbrechen</span>
              </Button>
              <Button
                :disabled="nextStepIsBlocked"
                styleButton="background"
                @click="goToNextStep"
              >
                <span>Nächster Schritt</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <OrganPipeVariants v-else />
</template>

<script>
import Button from '@/components/Button/Button';
import Heading from '@/components/Heading/Heading';
import Back from '@/components/Back/Back';
import OrganPipeVariants from '@/sections/Organ/OrganPipeVariants.vue';

export default {
  name: 'Organ',
  components: { OrganPipeVariants, Back, Heading, Button },
  props: {
    initialData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    organState() {
      return this.$store.state.organ;
    },
    isMobile() {
      return this.$store.state.global.isMobile;
    },
    globalSettings() {
      return this.$store.state.global.settings;
    },
    donations() {
      return this.organState.pipeDonations;
    },
    nextStepIsBlocked() {
      return (
        !this.$store.state.organ.pipeVariants ||
        !this.$store.getters['organ/currentPipeVariants'].prices.length
      );
    },
  },
  mounted() {
    // this.$store.commit('organ/showCheckoutPage');
    this.$store.commit(
      'organ/setPipeDonations',
      this.globalSettings.pipe_price_ranges
    );

    this.$store.dispatch('organ/fetchPipes');

    if (this.initialData && this.initialData.image) {
      this.$store.commit(
        'organ/setImage',
        this.initialData.image.sizes['medium_large']
      );
    }
  },
  methods: {
    goToNextStep() {
      if (this.nextStepIsBlocked) return;
      this.$store.commit('organ/showPipeVariantsScreen', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.page-info {
  background-color: #fff;
  margin: 30px 0;
  position: relative;

  &__buttons {
    display: flex;
    margin-top: 60px;
    width: 60%;
    margin-left: auto;
    margin-right: 0;
    gap: 25px;
  }

  &__donations {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  &__donation {
    //flex-basis: 30%;
    flex-grow: 1;
    font-size: 30px;
    color: #b98d57;
    background-color: #fff;
    border: 1px solid #b98d57;
    height: 60px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding-left: 60px;
    padding-right: 30px;
    position: relative;
    cursor: pointer;
    &:after {
      position: absolute;
      content: '';
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #b98d57;
    }

    &.active {
      background-color: #b98d57;
      color: #fff;
      &:after {
        border-width: 5px;
        border-color: #fff;
        width: 15px;
        height: 15px;
      }
    }
  }

  &__back {
    position: absolute;
    left: 10px;
    top: 10px;

    :deep(.back) {
      padding: 0;

      svg {
        fill: #fff;
      }
    }
  }

  &__container {
    padding: 20px;
  }

  &__image {
    border-bottom: 4px solid $gold_ci;

    img {
      width: 100%;
      display: block;
    }
  }

  &__heading {
    margin-bottom: 30px;
  }

  &__description {
    line-height: 150%;

    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4),
    :deep(h5),
    :deep(h6) {
      @include tcl_h3;
      margin-top: 50px;
      margin-bottom: 30px;
      color: $mittel_dunkelblau_ci;
    }

    :deep(li) {
      padding-left: 15px;
      margin-top: 20px;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        left: 0;
        top: 9px;
        width: 4px;
        height: 4px;
        background-color: $mittel_dunkelblau_ci;
        border-radius: 4px;
      }
    }
  }

  &__button {
    margin-top: 50px;
  }

  @media (min-width: $largeMobile) {
    margin-top: 0;
    background-color: transparent;

    :deep(h2:first-child) {
      margin-top: 0;
    }

    .row {
      align-items: center;
      .left {
        width: 380px;
        height: 380px;
      }
      .right {
        flex: 1;
        padding-left: 60px;
        .page-info__container {
          padding: 50px;
        }
      }
    }

    .page-info__heading {
      margin-bottom: 20px;
      :deep() {
        h1 {
          font-weight: 400;
        }
      }
    }

    .page-info__button {
      margin-top: 40px;
      width: max-content;

      .button {
        border-radius: 48px;
        padding: 0 30px;
      }
    }

    .page-info__description {
      font-weight: 500;

      &:deep() {
        ul {
          columns: 2;
          -webkit-columns: 2;
          -moz-columns: 2;
        }

        li:before {
          width: 8px;
          height: 8px;
          background-color: #444444;
        }
      }
    }

    .page-info__container {
      padding: 0 !important;
    }

    .page-info__image {
      border-bottom: none;
      & > div {
        height: 0;
        padding-bottom: 100%;
        position: relative;
      }
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
        border-radius: 50%;
      }
    }
  }
}

.page-info__text {
  margin-top: 30px;
  color: #b98d57;

  &-title {
    font-size: 20px;
    margin-bottom: 5px;
    font-weight: 500;
  }

  &-description {
    color: #b98d57;
  }

  &-links {
    margin-top: 20px;
    display: flex;
    gap: 30px;
    flex-wrap: wrap;

    a {
      display: flex;
      color: #b98d57;
      display: flex;
      align-items: center;
      gap: 10px;

      .icon {
        width: 20px;

        svg {
          display: block;
          height: auto;
        }
      }

      .label {
        flex: 1;
      }
    }
  }
}

@media (max-width: $largeMobile) {
  .page-info__heading {
    margin-bottom: 0;
  }
  .gray-background.page-info {
    margin-top: 0;
    margin-bottom: 0;
  }
  .page-info__donation {
    font-size: 24px;
  }
  .page-info__buttons {
    width: 100%;
    flex-direction: column-reverse;
  }
}
</style>
